module.exports = __webpack_public_path__ + "static/media/A TRIAL 1.d195a3a2.mp3";